import preview from './preview';
import edit from './edit';
import softDelete from './delete';

export default {
  preview,
  edit,
  softDelete
}